import { useState, useEffect } from "react";

const BASE = import.meta.env.BASE_URL.replace(/\/$/, "");

export function useAdminAuth(): { isAdmin: boolean | null; adminChecked: boolean } {
  const [adminChecked, setAdminChecked] = useState(false);
  const [isAdmin, setIsAdmin] = useState<boolean | null>(null);

  useEffect(() => {
    let cancelled = false;
    fetch(`${BASE}/api/auth/me`, { credentials: "include" })
      .then(r => r.ok ? r.json() : null)
      .then(data => {
        if (!cancelled) {
          setIsAdmin(data?.isAdmin === true);
          setAdminChecked(true);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setIsAdmin(false);
          setAdminChecked(true);
        }
      });
    return () => { cancelled = true; };
  }, []);

  return { isAdmin, adminChecked };
}
